let filterAccountOverview = document.querySelector("[data-js='filterAccountOverview']");
let filterSelectionButton = document.querySelector(".m-f-selection-btn");
let filterSortButton = document.querySelector(".m-f-sort-btn");
let filterSelectionReset = document.querySelector(".list-filter-selection-reset");
let filterListItemSelection = document.querySelectorAll(".list-filter-selection-item");

// When Filter exists
if (filterAccountOverview) {

	filterSelectionButton.addEventListener("click", function () {
		$("#m-f-selection-account-overview").modal("show");
	});

	filterSortButton.addEventListener("click", function () {
		$("#m-f-sort-account-overview").modal("show");
	});

	filterListItemSelection.forEach(item => {
		let filterListItemSelectionCheckboxes = document.getElementsByClassName("vh");
		let filterListItemSelectionCount;

		for (filterListItemSelectionCount = 0; filterListItemSelectionCount < filterListItemSelectionCheckboxes.length; filterListItemSelectionCount++) {
			filterListItemSelectionCheckboxes[filterListItemSelectionCount].addEventListener("click", function () {
				let checkCount = item.querySelectorAll("input[type='checkbox']:checked").length;
				if (checkCount > 0) {
					item.querySelector(".checkcount").classList.add("show");
					item.querySelector(".checkcount").innerHTML = checkCount;
				} else {
					item.querySelector(".checkcount").classList.remove("show");
				}

				let checkCountAll = document.querySelectorAll("input[type='checkbox']:checked").length;
				if (checkCountAll > 0) {
					filterSelectionButton.querySelector("span").classList.add("active");
				} else {
					filterSelectionButton.querySelector("span").classList.remove("active");
				}
			});
		}
	});

	filterSelectionReset.addEventListener("click", function () {
		let uncheck = document.getElementsByTagName("input");
		let uncheckCount;
		let filterCheckcountItem = document.querySelectorAll(".checkcount");

		[].forEach.call(filterCheckcountItem, function (el) {
			el.classList.remove("show");
		});

		for (uncheckCount = 0; uncheckCount < uncheck.length; uncheckCount++) {
			if (uncheck[uncheckCount].type == "checkbox") {
				uncheck[uncheckCount].checked = false;
			}
		}

		filterSelectionButton.querySelector("span").classList.remove("active");
	});

	let coll = document.getElementsByClassName("collapsible");
	let collCount;

	for (collCount = 0; collCount < coll.length; collCount++) {
		coll[collCount].addEventListener("click", function () {
			this.classList.toggle("active");
			let content = this.nextElementSibling;
			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
			}
		});
	}
}